import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import i18n from './locales'
import './styles/index.css'
import { setupErrorLogger } from './composables/useErrorLogger'
import vLoading from './directives/loading.ts'
import { kickoffWallpaperPreload } from './utils/wallpaperPreload'

// 壁纸与 App/SDK 模块图并行：静态 import App 会先跑完整棵依赖再执行正文
kickoffWallpaperPreload()

/**
 * 将异步模块加载收进启动函数，避免产物保留顶层 await 而降低浏览器兼容性。
 */
async function bootstrap() {
  const { default: App } = await import('./App.vue')

  const app = createApp(App)
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)

  // 初始化错误监听
  setupErrorLogger(app, {
    reportWarning: true,
    enableInDev: false, // 开发环境是否启用
  })

  app.use(pinia)
  app.use(router)
  app.use(i18n)

  app.directive('loading', vLoading)

  app.mount('#app')
}

void bootstrap()
